import { EditorState } from '@common/Common';
import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { RevenueEditorFormSubmitEventPayload, RevenueEditorViewModel } from '@Quest/Financials/Revenues/Components/RevenueEditor';
import RevenueEditor from '@Quest/Financials/Revenues/Components/RevenueEditor.vue';
import { CreateRevenueAccountCommandV1, DeleteRevenueAccountCommandV1, UpdateRevenueAccountCommandV1 } from '@Quest/Financials/Revenues/Domain/commands-core';
import RevenuesCommands from '@Quest/Financials/Revenues/Domain/commands-vue-component';
import RevenuesQueries from '@Quest/Financials/Revenues/Domain/queries-vue-component';
import { RevenueAccountReadModel, RevenueAccountsReadModel } from '@Quest/Financials/Revenues/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';

@Component({
    components: { CorporateNavigation, RevenueEditor }
})
export default class RevenuesPage extends mixins(RevenuesQueries, RevenuesCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: RevenueAccountsReadModel | null = null;
    revenueEditor: RevenueEditorViewModel | null = new RevenueEditorViewModel();


    showRevenueCreator()
    {
        this.revenueEditor.showCreator();
    }

    showRevenueEditor(r: RevenueAccountReadModel)
    {
        this.revenueEditor.showEditor(r.Id, r.Name, r.Description);
    }


    handleRevenueEditorFormSubmit(e: RevenueEditorFormSubmitEventPayload)
    {
        if (this.revenueEditor.state === EditorState.Creator)
        {
            this.invokeCreateRevenueAccountCommandV1(this.workspaceId, this.strategyId, guid(), e.name, e.description);
        }
        else if (this.revenueEditor.state === EditorState.Editor)
        {
            this.invokeUpdateRevenueAccountCommandV1(this.workspaceId, this.strategyId, e.id, e.name, e.description);
        }
    }

    handleDeleteRevenueAccountCommand(rev: RevenueAccountReadModel)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteRevenueAccountCommandV1(this.workspaceId, this.strategyId, rev.Id);
        }
    }


    mounted()
    {
        document.title = "Revenues | TransparentChoice";
        this.runRevenueAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
    }


    onSetModel(model: any, modelName: string)
    {
        if (modelName === "RevenueAccountsReadModel")
        {
            this.rm = model as RevenueAccountsReadModel;
            this.revenueEditor.close();
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateRevenueAccountCommandV1.matchType(cmd))
        {
            this.runRevenueAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
        }
        else if (UpdateRevenueAccountCommandV1.matchType(cmd))
        {
            this.runRevenueAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
        }
        else if (DeleteRevenueAccountCommandV1.matchType(cmd))
        {
            this.runRevenueAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
        }
    }
}